import styled from 'styled-components';

export const TreeMapWrapper = styled.div`
  height: 300px;
  position: relative;
`

export const SidePanel = styled.div`
  display: flex;
  position: absolute;
  right: 5px;
  top: 20px;
  width: 65px;
  flex-direction: column;

  button {
    padding: 0;
    span {
      width: 100%;
    }
  }
`

export const StyleBreadItem = styled.div`
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  min-width: 0;
  color: rgba(0, 0, 0, 0.45);
  & > div:first-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 4px;
    border-radius: 4px;
    &:hover {
      color: rgba(0, 0, 0, 0.88);
      background-color: rgba(0, 0, 0, 0.06);
      cursor: pointer;
    }
  }
  & > span {
    margin-inline: 8px;
  }
  &:last-child {
    & > span {
      display: none;
    }
  }
`

export const StyleBreadcrumb = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  overflow: hidden;
  justify-content: center;
`

export const LegendWrapper = styled.div<{ $color?: string }>`
  text-align: left;
  font-size: 13px;
  color: ${({ $color }) => $color ? '#000' : '#ccc'};
  & > span {
    &::before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 5px;
      background-color: ${({ $color }) => $color || '#ccc'};
    }
  }
`
